import React from "react";
import { observable, makeObservable } from "mobx";
import { OrbitComponent } from "../base-components/orbit-component/orbit-component";
import { observer } from "mobx-react";
import { Select } from "../../basic-ui-components/form/select.component";
import {Label} from "./boxes/label";

interface IShowcaseDropdownComponentProps<T> {
    fieldName: string;
    caption: string;
    defaultValue?: T | undefined;
    values: T[];
    onChanged: (fieldName: string, value: T) => void;
}

@observer
export class ShowcaseDropdownComponent<T = string> extends OrbitComponent<IShowcaseDropdownComponentProps<T>> {
    @observable
    currentValue: T = this.props.defaultValue;

    constructor(props: IShowcaseDropdownComponentProps<T>) {
        super(props);

        makeObservable(this);
    }

    render() {
        let optionsTemplate = [undefined].concat(this.props.values).map((value: T | undefined) => {
            const display = value === undefined ? "NOT SET" : value.toString().toUpperCase();
            return <option key={display} value={value ? value.toString() : ''}>{display}</option>
        });

        return <div style={{fontSize: "1.6rem", width: "250px"}}>
            <Label htmlFor={this.props.fieldName}>{this.props.caption}</Label>
            <Select
                name={this.props.fieldName}
                id={this.props.fieldName}
                value={this.props.defaultValue as any}
                onChange={(e) => {
                    this.currentValue = e.target.options[e.target.selectedIndex].value as any;
                    this.props.onChanged(this.props.fieldName, this.currentValue);
                }}
                width="100%"
            >
                {optionsTemplate}
            </Select>
        </div>;
    }
}
